import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as mobileUpdateActions from 'action/mobileUpdateNew'
import ContentHeader from 'component/utils/ContentHeader'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import SizeSelect, {components} from 'react-select'
import { colourStyles } from 'utils/selectStyle'
import ReleasesTable from 'component/mobileUpdatesNew/NewTable'
import Modal, { MODAL_TYPE } from 'component/mobileUpdatesNew/Modal'
import DownloadIconSVG from 'component/svgComponents/download'
import Button from 'component/Button'
import SuccessModal from 'component/Modal/SuccessModal'
import NewPagination from 'component/pagination/newPagination'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import './styles.css'
import { isEmpty } from 'lodash'

const DEFAULT_MODAL_VALUES = {
  idUpdate: "",
  idVersion: '',
  dsLdap: [],
  store: [],
  updateNotes: '',
}
const PAGINATION_HEIGHT = 71
// Search and Filter
const TOP_ACTIONS = 95
// TOOLBAR + Title
const TOP_BAR = 67 + 50

class MobileUpdateContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    removed: PropTypes.bool,
    mobileUpdates: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchMobileUpdates: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
  }
  

  constructor() {
    super()
    this.successModal = this.successModal.bind(this);
    this.state = {
      height: 0,
      page: 1,
      size: 10,
      apkDownloadUrl: '',

      pagination: {
        page: 1,
        size: 10,
      },
      modal: {
        type: null,
        data: DEFAULT_MODAL_VALUES,
      },
      success: {
        type: null,
      },
    }
  }

  getApkDownloadUrl(values) {
    const {auth: { user }} = this.props
    return new Api(user.dsToken)
      .get(API_URL.PARAMETER_GET, values)
      .then(resp => {
        this.setState({apkDownloadUrl: resp.data})
      })
      .catch(() => {
        this.setState({apkDownloadUrl: ''})
      })
  }

 
  componentDidMount() {
    const { fetchMobileUpdates, auth: { user } } = this.props;

    fetchMobileUpdates(user.dsToken);
    
    const params = {
      dsKey: "apk.download.url",
      nuParameter: 1
    }
    this.getApkDownloadUrl(params);
    // Function to update the height and fetch updates
    const calculateHeight = () => {
      this.setState({ height: window.innerHeight });
     
    };

    // Set initial height and fetch updates
    calculateHeight();

    // Set the event listener for window resizing
    window.addEventListener("resize", calculateHeight);

    // Clean up the event listener when the component is unmounted
    this.cleanupResizeListener = () => {
      window.removeEventListener("resize", calculateHeight);
    };
  }

  componentWillUnmount() {
    // Cleanup the resize event listener when the component is unmounted
    if (this.cleanupResizeListener) {
      this.cleanupResizeListener();
    }
  }

  componentDidUpdate(_, prevState) {
    // Check if height has changed
    if (this.state.height !== prevState.height) {
      if (this.state.height < 868 && this.state.height !== 0) {
        const responsiveHeight = this.state.height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100);
        const tbody = document.querySelector('.tbody-mission-block');
        if (tbody) {
          tbody.style.maxHeight = `${responsiveHeight}px`;
        }
      } else {
        const tbody = document.querySelector('.tbody-mission-block');
        if (tbody) {
          tbody.style.maxHeight = `500px`;
        }
      }
    }
  }

  
  successModal = () => {
      const {modal: {type}} = this.state
      this.setState({
      success: { type },
    }, () => this.closeModal())
  }

  handleSubmit(toSave, idUpdate) {
    const {update, auth: {user}} = this.props
    let toSend = {cdMission: "",dsBranch: "", dsLdap: "", idVersion: "", inUpdate: 0}
    
    toSend = {
      ...toSend,
      ...toSave
    }

    if(!isEmpty(toSave.store) && Array.isArray(toSave.store)) {
      const idBranch = toSave.store[0]
      toSend.idBranch = idBranch
    }

    if(!isEmpty(toSave.dsLdap)) {
      toSend.dsLdap = toSave.dsLdap.join(",")
    }

    if(idUpdate) {
      toSend.idUpdate = idUpdate
    }

    update(user.dsToken, toSend, this.successModal)
    
  }

  handleDelete(toRemove) {

    const request = {}
    request.idUpdate = toRemove.idUpdate
    request.idVersion = toRemove.idVersion
    request.inUpdate = 0
    const {
      remove,
      auth: { user }
    } = this.props

    remove(user.dsToken, request, this.successModal)
  }

  handlePublish() {
  
    // const {
    //   publish,
    //   auth: { user }
    // } = this.props

    // publish(user.dsToken, toPublish).then(() => this.setState({
    //   success: { type }
    // }))
  }

  handleUpdate(toUpdate) {
    
    const request = {...toUpdate}
    delete request.store
    delete request.dsLdap
    if(!isEmpty(toUpdate.dsLdap)) {
      request.dsLdap = toUpdate.dsLdap.join(",")
    }
    request.inUpdate = 1
    const {
      update,
      auth: { user }
    } = this.props

    update(user.dsToken, request, this.successModal)
  }

  renderNewPagination = () => {
    const {translate, pages,count, mobileUpdates, current} = this.props
    const {size} = this.state
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]
      
    const countItems = () => {

      if(current  === 1) return 1

      return (((current ) - 1) * size) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    // if(!(mock.content ?? []).length) return
    if(isEmpty(mobileUpdates)) return 
    // console.log("Paginação", mock.content)

    return (
                 <Row className="new-relatory-row stock-transfer-pagination" >
                      <Col className="align-center margin-bottom ">

                      <NewPagination
                      navClass='pagination new-relatory'
                      count={count}
                      current={current}
                      getPage={(page) => this.getPage(page)}
                      pages={pages}
                    />

                    <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
                            <Col xs={4}>
                              <SizeSelect
                              components={{DropdownIndicator}}

                                isSearchable={false}
                                styles={colourStyles}
                                classNamePrefix='react-select'
                                onChange={(option) => {
                                  this.getSize(option.value)
                                }}
                                options={PAGINATION_OPTIONS}
                                value={PAGINATION_OPTIONS.find((i) => i.value === size)}
                                menuPlacement='top'
                              />
                            </Col>
                      </div>


                      <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                            <Col >{`
                            ${translate('pagination.size.show')}
                            ${countItems()} - ${(current) * size > count ? count : (current ) * size }
                            ${translate("pagination.size.of")}
                            ${count}
                            ${translate("pagination.size.items")}`}</Col>

                      </div>

                    </Col>


                  </Row>
    )

  }

  openModal(type, data) {
    this.setState({
      modal: {
        type,
        data: data && {
          ...DEFAULT_MODAL_VALUES,
          ...(data.idUpdate && {idUpdate: data.idUpdate}),
          ...(data.idVersion && { idVersion: data.idVersion }),
          ...(data.dsLdap && { dsLdap: data.dsLdap }),
          ...(data.store && { store: data.store }),
          ...(data.idBranch && { idBranch: data.idBranch }),
          ...(data.dsBranch && { dsBranch: data.dsBranch }),
          ...(data.updateNotes && { updateNotes: data.updateNotes }),
        },
      },
    })
  }

  closeModal() {
    this.setState({
      modal: { type: null, data: DEFAULT_MODAL_VALUES },
    })
  }

  renderModal() {
    const {
      translate,
      auth: { user },
      mobileUpdates,
    } = this.props
    const {
      modal: { type, data },
      apkDownloadUrl,
    } = this.state

    return (
      <Modal
        closeModal={() => this.closeModal()}
        handleDelete={(data) => this.handleDelete(data)}
        handleUpdate={(data) => this.handleUpdate(data)}
        handlePublish={(data) => this.handlePublish(data)}
        handleSubmit={(data,idUpdate) => this.handleSubmit(data,idUpdate)}
        data={data}
        type={type}
        translate={translate}
        user={user}
        mobileUpdates={mobileUpdates}
        apkDownloadUrl={apkDownloadUrl}
      />
    )
  }

  renderSuccessModal() {
    const {
      fetchMobileUpdates,
      auth: { user },
      translate,
    } = this.props
    const {
      success: { type },
      page,
      size
    } = this.state

    const successMessage = (type) => {
      switch (type) {
        case MODAL_TYPE.PUBLISH:
          return translate('mobile.update.publish.success.message')
        case MODAL_TYPE.UPDATE:
          return translate('mobile.update.update.success.message')
        case MODAL_TYPE.DELETE:
          return translate('mobile.update.delete.success.message')
        case MODAL_TYPE.CREATE:
        case MODAL_TYPE.EDIT:
          return translate('mobile.update.create.success.message')
        case MODAL_TYPE.WRITE:
        case MODAL_TYPE.REWRITE:
          return translate('mobile.update.write.rewrite.edit.success.message')
        default:
          return ''
      }
    }

    return (
      <SuccessModal
        size='sm'
        handleClose={() =>
          this.setState(
            {
              success: {
                type: null,
              },
            },
            () => fetchMobileUpdates(user.dsToken, page, size)
          )
        }
        msg={successMessage(type)}
        t={translate}
        center
        buttonText='OK'
      />
    )
  }

  getPage = (p) => {
    const {
      auth: { user },
      fetchMobileUpdates,
    } = this.props
    const { size } = this.state

    this.setState({
      page:p
    })

    fetchMobileUpdates(user.dsToken, p, size)
  }

  getSize = (size) => {
    const {
      auth: { user },
      fetchMobileUpdates,
    } = this.props

    this.setState({
      size,
      page: 1
    })

    fetchMobileUpdates(user.dsToken, 1, size)
  }

  render() {
    const { translate,  mobileUpdates } = this.props
    const {

      modal,
      success,
    } = this.state

    return (
      <section className='new-release-updates'>
        <ContentHeader>{translate('release.updates')}</ContentHeader>
        <div className='new-style-filter margin-bottom'>
          <section style={{paddingLeft: "16px", paddingRight: "16px"}} className='container-fluid new-upper-container'>
            <div className='float-right'>
              <Button
                className='btn btn-primary margin-right-updates'
                text={translate('mobile.update.new.liberation')}
                onClick={() => this.openModal(MODAL_TYPE.CREATE)}
              />
              <Button
                disabled
                className='btn btn-secondary margin-right-updates'
                text={translate('mobile.update.write.web.update')}
                onClick={() => this.openModal(MODAL_TYPE.WRITE)}
              />
              <Button
                className='btn last btn-secondary'
                text={translate('mobile.update.download')}
                onClick={() => this.openModal(MODAL_TYPE.DOWNLOAD)}
                svgIcon
                svgComponent={<DownloadIconSVG className="download-svg-small svg-green" />}

              />
            </div>
          </section>
        </div>
        <section id='release-update-data-section' className='stock-adjustment-table new'>
          {mobileUpdates.length ? (
            <div id='release-update-table' style={{boxShadow: (!isEmpty(mobileUpdates) && mobileUpdates || []).length < 1 && 'none'}} className='outer-table' >

                  <ReleasesTable
                    mobileUpdates={mobileUpdates}
                    openModal={(type, data) => this.openModal(type, data)}
                    translate={translate}
                  />
              
            </div >
          ) : (
            <div>
             <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
                
                <p>Sem resultado de busca</p>
               
              </div>
            </div>
          )}
          {this.renderNewPagination()}
        </section>

        {modal.type && this.renderModal()}
        {success.type && this.renderSuccessModal()}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = ({ mobileUpdateReducer, paginateReducer }) => ({
  mobileUpdates: mobileUpdateReducer.list.records,
  updated: mobileUpdateReducer.edit.updated,
  removed: mobileUpdateReducer.edit.removed,
  error: mobileUpdateReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  size: paginateReducer.size,
  current: paginateReducer.current,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(mobileUpdateActions, dispatch)

/*
 * Connects component to I18next
 */
const MobileUpdateTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MobileUpdateContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileUpdateTranslated)

/*
 * Exports as component
 */
export { MobileUpdateContainer as MobileUpdate }
